import React from 'react';
import MissionalRangeBar from './MissionalRangeBar';

const ResourceCard = ({
  resource,
  number,
  onEdit,
  onDuplicate,
  onDelete,
  onReorder,
  isFirst,
  isLast,
  previewMode = false,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
      <div className="flex items-start gap-4">
        {/* Number (and reorder only when managing) */}
        <div className="flex-shrink-0">
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 bg-gray-400 text-white rounded-full flex items-center justify-center mb-1">
              {number}
            </div>
            {!previewMode && (
              <div className="flex flex-col gap-1">
                {!isFirst && (
                  <button
                    type="button"
                    onClick={() => onReorder(resource.id, 'up')}
                    className="text-gray-500 hover:text-[#0076BE]"
                    title="Move up"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  </button>
                )}
                {!isLast && (
                  <button
                    type="button"
                    onClick={() => onReorder(resource.id, 'down')}
                    className="text-gray-500 hover:text-[#0076BE]"
                    title="Move down"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="flex-grow">
          <div className="flex justify-between items-start gap-3">
            <h3 className="text-lg font-medium mb-2">{resource.title}</h3>
            {!previewMode && (
              <div className="flex gap-3 shrink-0">
                <button
                  type="button"
                  onClick={() => onDuplicate(resource.id)}
                  className="text-gray-500 hover:text-gray-700 text-sm"
                >
                  Duplicate
                </button>
                <button
                  type="button"
                  onClick={() => onEdit(resource.id)}
                  className="text-gray-500 hover:text-gray-700 text-sm"
                >
                  Edit
                </button>
                <button
                  type="button"
                  onClick={() => onDelete(resource.id)}
                  className="text-red-500 hover:text-red-700 text-sm"
                >
                  Delete
                </button>
              </div>
            )}
          </div>

          {/* Missional Range Bar */}
          <div className="mb-3">
            <MissionalRangeBar 
              min={resource.missionalRange?.min || -10} 
              max={resource.missionalRange?.max || -10}
            />
          </div>

          <p className="text-gray-600 mb-3">{resource.description}</p>

          {/* Resource Details */}
          <div className="flex items-center text-sm text-gray-500 mb-3">
            <span className="capitalize">{resource.type}</span>
            {resource.duration && (
              <span className="ml-2">• {resource.duration}</span>
            )}
            {resource.status === 'draft' && (
              <span className="ml-2 px-2 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-semibold">Draft</span>
            )}
          </div>

          {/* View Resource Link */}
          <a
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0076BE] hover:text-[#005c94] text-sm font-medium inline-flex items-center"
          >
            {previewMode ? 'Open resource' : 'View Resource'}
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResourceCard; 